import { Checkbox } from "@blueprintjs/core";
import { FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { DysplasiaApi, UserDysplasiaResultGridDto, UserDysplasiaResultSearch } from "../../api";
import { CustomDataTable } from "../../components";
import { useApiService, useTl } from "../../hooks";
import { ETLCodes } from "../../locales";

export interface IVeterinaryGridProps {
  dysplasiaRequestId: number;
  dysplasiaTypeId: number;
}

export const VeterinaryGrid: React.FunctionComponent<IVeterinaryGridProps> = ({
  dysplasiaRequestId,
  dysplasiaTypeId,
}) => {
  const api = useApiService(DysplasiaApi);
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: false,
    enableFilter: false,
    availablePageSizes: [15, 25, 50],
    pageSize: 50,
    sortKeys: { veterinary: "DESC", orderIndex: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: UserDysplasiaResultSearch) => {
      return api.searchDysplasiaUserResult(
        UserDysplasiaResultSearch.fromJS({
          ...sObj,
          dysplasiaRequestId: dysplasiaRequestId,
          dysplasiaTypeId: dysplasiaTypeId,
        })
      );
    },
    [api, dysplasiaRequestId, dysplasiaTypeId]
  );

  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.Veterinary),
        fieldName: "veterinary",
      },
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.Characteristic),
        fieldName: "characteristicTranslation",
      },
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.IsRefused),
        fieldName: "isRefused",
        render: (row: UserDysplasiaResultGridDto) => <Checkbox checked={row.isRefused} disabled />,
      },
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.OfficialRemark),
        fieldName: "officialRemark",
      },
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.Note),
        fieldName: "healthValue",
      },
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.Remark),
        fieldName: "otherRemark",
      },
    ],
    [t]
  );

  return (
    <FieldSet title={t(ETLCodes.OtherMembersDecision)} collapsable>
      <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
